import { component } from 'picoapp';
import { subscribe } from 'klaviyo-subscribe';

export default component((node) => {
  let hiddenPassword = '';
  const inputFields = node.querySelectorAll('[data-field]');
  const hiddenPasswordInput = node.querySelector('[type="password"]');
  const inputFieldsParent = node.querySelector('[data-inputfields]');
  const formSubmitBtn = node.querySelector('[data-submit]');

  const klaviyoModalTrigger = node.querySelector('[data-trigger-modal]');

  /* Klaviyo trigger */
  if (klaviyoModalTrigger) {
    klaviyoModalTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('klaviyo:modal', { detail: { id: klaviyoModalTrigger.dataset.triggerModal } }));
    });
  }

  // We need to update the hidden input element that contains the actual password
  const updateHiddenPassword = () => {
    hiddenPassword = '';
    inputFields.forEach((element) => {
      hiddenPassword += element.value;
    });
    hiddenPasswordInput.value = hiddenPassword;

    if (hiddenPassword.length >= 4) {
      formSubmitBtn.innerHTML = window.blackfriday.translations.submit_active;
      formSubmitBtn.classList.add('submit--active');
    } else {
      formSubmitBtn.innerHTML = window.blackfriday.translations.submit_inactive;
      formSubmitBtn.classList.remove('submit--active');
    }
  };

  // Select first input field if they are all empty
  inputFieldsParent.addEventListener('click', (e) => {
    e.preventDefault();
    if (hiddenPassword === '') {
      inputFields[0].focus();
    }
  });

  inputFields.forEach((val, key, arr) => {
    val.addEventListener('input', (event) => {
      val.value = '';
      val.value = event.data;
      updateHiddenPassword();
      if (!Object.is(arr.length - 1, key)) {
        // Doesn't run on last element in array
        val.nextElementSibling.focus();
      }
    });
  });

  // Klaviyo signup
  const mailForm = node.querySelector('#blackfriday__newsletter');
  const listId = window.blackfridayKlaviyo;
  const mailSubmit = node.querySelector('[data-submit-newsletter]');

  mailForm.addEventListener('keyup', () => {
    const name = node.querySelector('[data-name]').value;
    const email = node.querySelector('[data-mail]');

    const isValidEmail = email.checkValidity();
    if (isValidEmail && name !== '') {
      mailSubmit.classList.add('submit--active');
    } else {
      mailSubmit.classList.remove('submit--active');
    }
  });

  mailForm.addEventListener('submit', (e) => {
    e.preventDefault();
    mailSubmit.innerHTML = window.blackfriday.translations.mail_loading;
    const name = node.querySelector('[data-name]').value;
    const email = node.querySelector('[data-mail]').value;

    subscribe(listId, email, {
      $first_name: name,
    }).then(() => {
      mailSubmit.innerHTML = window.blackfriday.translations.mail_finished;
      mailSubmit.setAttribute('disabled', true);
    });
  });
});
